import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useAppStore } from "../../hooks/useStores";
import { usePluginsUtils } from "../../utils/usePluginsUtils";

function PluginsAuth() {
	const { authStore } = useAppStore();
	const { handleSelectOrganization } = usePluginsUtils();

	useEffect(() => {
		if (authStore.isPluginAuth) {
			handleSelectOrganization();
		}
	}, [authStore.user]);

	return null;
}

export default observer(PluginsAuth);
